"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
/**
 * Provide a `title` as an accessible label intended for screen readers.
 */
var Icon = function (_a) {
    var name = _a.name, className = _a.className, title = _a.title;
    return (react_1["default"].createElement("span", null,
        react_1["default"].createElement("svg", { className: "icon icon-" + name + " " + (className || ''), "aria-hidden": "true" },
            react_1["default"].createElement("use", { href: "#icon-" + name })),
        title ? (react_1["default"].createElement("span", { className: "visuallyhidden" }, title)) : null));
};
Icon.propTypes = {
    name: prop_types_1["default"].string.isRequired,
    className: prop_types_1["default"].string,
    title: prop_types_1["default"].string,
};
Icon.defaultProps = {
    className: null,
    title: null,
};
exports["default"] = Icon;
